"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatedApiKey = void 0;
/**
 * Represents api key information including the secret
 */
var CreatedApiKey = /** @class */ (function (_super) {
    __extends(CreatedApiKey, _super);
    function CreatedApiKey() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "CreatedApiKey";
        /**
         * The api key id
         */
        _this.apiKeyId = function () {
            _this.push(function (_) { return "apiKeyId"; });
        };
        /**
         * The name of the api key
         */
        _this.name = function () {
            _this.push(function (_) { return "name"; });
        };
        /**
         * The description of the api key
         */
        _this.description = function () {
            _this.push(function (_) { return "description"; });
        };
        /**
         * The secret of the api key
         */
        _this.secret = function () {
            _this.push(function (_) { return "secret"; });
        };
        /**
         * The flag to enable the api key
         */
        _this.enabled = function () {
            _this.push(function (_) { return "enabled"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return CreatedApiKey;
}(Array));
exports.CreatedApiKey = CreatedApiKey;
//# sourceMappingURL=CreatedApiKey.js.map